export const STYLE_TYPE_ALIASES = {
  'amber & red ales': 'Amber & Red',
  'brown ales': 'Brown Ale',
  'non alcoholic beers': 'Non-Alcoholic',
  'non-alcoholic beers': 'Non-Alcoholic',
  other: 'Other Styles',
  ipa: 'India Pale Ales (IPA)',
  ipas: 'India Pale Ales (IPA)',
};

export function canonicalizeStyleTypeName(rawType) {
  if (typeof rawType !== 'string') {
    return '';
  }
  const trimmed = rawType.trim();
  if (!trimmed) {
    return '';
  }
  return STYLE_TYPE_ALIASES[trimmed.toLowerCase()] ?? trimmed;
}
